/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import {
  doctorOnlineData,
  setForumReadComments,
  setForumReadTopics,
  setTotalDoctors
} from "../../reduxStore/actions/commonAction";
import Label from "../../components/label";
import appRoutes from "../../routes/appRoutes";
import ImageToUpload from "../../assets/images/background-1.jpg";
import axios from "axios";
import { getHomePageData, getOrderHistoryWithFilterAPI, internetConnectionFileUpload, patientsInQueue, getTodayAssessmentCount } from "../../apiRoutes";
import Model from "../../components/modal";
import { CircularProgress } from "@material-ui/core";
import MakeAPICall from "../../apiCalls/common";
import InstantExtrasLogo from "../../assets/images/instant_extra_logo.png";
import InstantSwitchLogo from "../../assets/images/instant_switch_logo.png";
import InstantHushLogo from "../../assets/images/instant_hush_logo.png";
import InstantLeafLogo from "../../assets/images/medicinal_cannabis_logo.png";
import { Tooltip } from "reactstrap";

class SideNavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      internetConnectionModelOpen: false,
      poorInternetConnection:
        "Your internet connection is not suitable for a video call. <br/>  Please check your internet connection and try again.",
      internetConnectionModelBody: null,
      testingConnectionLoader: false,
      apiCall: null,
      apiCall2: null,
      // apiCallHush: null,
      // apiCallLeaf: null,
      // apiCallSwitch: null,
      apiCallTodayAssessmentCount: null,
      patientsInQueue: 0,
      showForumTooltip: false,
      hushToBeAssessedToday: "0",
      leafToBeAssessedToday: "0",
      switchToBeAssessedToday: "0",
      isInstantConsultAccessGranted: false,
      isInstantSwitchAccessGranted: false,
      isInstantHushAccessGranted: false,
      isInstantLeafGranted: false
    };
  }

  checkInternetConnection = () => {
    this.setState({
      testingConnectionLoader: true
    });

    let startTime = new Date().getTime(),
      file = ImageToUpload + "?" + new Date().getTime();

    axios
      .get(file, {
        responseType: "blob",
        timeout: 20000
      })
      .then(res => {
        console.log("File Got: ", res);
        let endTime = new Date().getTime(),
          duration = (endTime - startTime) / 1000,
          fileSize = 2900000,
          bitsLoaded = fileSize * 8,
          bps = (bitsLoaded / duration).toFixed(2),
          kbps = (bps / 1024).toFixed(2),
          mbps = (kbps / 1024).toFixed(2);

        let downloadSpeed = mbps;

        this.calculateUploadingSpeed(res, file, downloadSpeed);
      })
      .catch(error => {
        console.log("Got the error");
        this.setState({
          internetConnectionModelBody: null,
          internetConnectionModelOpen: true,
          testingConnectionLoader: false
        });
      });
  };

  calculateUploadingSpeed = (data, file, downloadSpeed) => {
    let formData = new FormData(),
      startTime1 = new Date().getTime(),
      fileURL = new File([data.data], file, { type: "image/jpeg" });

    formData.append("picture", fileURL, fileURL.name);

    axios
      .post(internetConnectionFileUpload, formData, {
        headers: {
          authorization: "bearer " + this.props.auth.accessToken,
          "content-type": undefined
        },
        timeout: 20000
      })
      .then(data => {
        console.log("2nd Function data: ", data);
        let endTime1 = new Date().getTime(),
          duration1 = (endTime1 - startTime1) / 1000,
          fileSize1 = 2900000,
          bitsLoaded1 = fileSize1 * 8,
          bps1 = (bitsLoaded1 / duration1).toFixed(2),
          kbps1 = (bps1 / 1024).toFixed(2),
          mbps1 = (kbps1 / 1024).toFixed(2);

        let uploadSpeed = mbps1,
          minUploadSpeed = 1.0,
          // minDownloadSpeed = 5.0,
          minDownloadSpeed = 4.0,
          dicon = "",
          uicon = "",
          internetStatus = false;

        if (downloadSpeed && uploadSpeed) {
          console.log("Hide Loader Now");

          // Check internet speed here
          if (
            downloadSpeed >= minDownloadSpeed &&
            uploadSpeed >= minUploadSpeed
          ) {
            internetStatus = true;
          } else {
            internetStatus = false;
          }

          // now for icon color
          downloadSpeed < minDownloadSpeed ? (dicon = "bad") : (dicon = "good");
          uploadSpeed < minUploadSpeed ? (uicon = "bad") : (uicon = "good");

          this.setState({
            testingConnectionLoader: false
          });

          if (internetStatus) {
            this.setState({
              internetConnectionModelBody: `<i class="fas fa-wifi fa-3x mt-2 good"></i> <p class="m-0 p-0 mt-4 speedTestTitle">Speed Test Results</p> <p class="p-0 m-0 mt-1 speedTestRes"> <span class="${dicon}"> ${downloadSpeed} mbps DL </span> |  <span class="${uicon}"> ${uploadSpeed} mbps UL </span> </p> <p class="m-0 p-0 mt-4 speedTestReqTitle">Minimum Requirements</p> <p class="p-0 m-0 mt-1 speedTestReqText">4 mbps DL | 1 mbps UL </p> `,
              internetConnectionModelOpen: true
            });
          } else {
            this.setState({
              internetConnectionModelBody: `<i class="fas fa-wifi fa-3x mt-2 bad"></i> <p class="m-0 p-0 mt-4 speedTestTitle">Speed Test Results</p> <p class="p-0 m-0 mt-1 speedTestRes">  <span class="${dicon}">  ${downloadSpeed} mbps DL </span> | <span class="${uicon}"> ${uploadSpeed} mbps UL </span> </p> <p class="m-0 p-0 mt-4 speedTestReqTitle">Minimum Requirements</p> <p class="p-0 m-0 mt-1 speedTestReqText">4 mbps DL | 1 mbps UL </p> <p class="mt-4 font-15"> Your internet speed is very slow. <br/> Please try again when you have <br/> a stronger internet connection. </p> `,
              internetConnectionModelOpen: true
            });
          }
        }
      })
      .catch(err => {
        console.log("In the error function : ", err);
        this.setState({
          internetConnectionModelBody: null,
          internetConnectionModelOpen: true,
          testingConnectionLoader: false
        });
      });
  };

  closeInternetConnectionModel = () => {
    this.setState({
      internetConnectionModelOpen: false
    });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {

  }

  componentDidMount() {
    setTimeout(() => {
      this.getDoctorOnlineData(); // for the first time when page loads
      this.getAssessmentsCount();
    }, 100);
    setTimeout(() => {
      this.getPatientsInQueue();
    }, 200);
    // setTimeout(() => {
    //   this.getForumPostUnreadCount();
    // }, 300);
    // setInterval(this.getDoctorOnlineData, 10000); // every 10s calling this function // TODO - We are removing this call from front-end and using socket event from backend
    // setInterval(this.getPatientsInQueue, 12000); // every 12s calling this function // TODO - We are removing this call from front-end and using socket event from backend
    // setInterval(this.getForumPostUnreadCount, 5000); //every 5 sec // TODO - We are removing this call from front-end and using socket event from backend
    this.setUserAccess();
  };

  setUserAccess() {
    const isInstantConsultAccessGranted = this.props.commonReducer && this.props.commonReducer.accessGranted && this.props.commonReducer.accessGranted.isInstantConsultAccessGranted;
    const isInstantSwitchAccessGranted = this.props.commonReducer && this.props.commonReducer.accessGranted && this.props.commonReducer.accessGranted.isInstantSwitchAccessGranted;
    const isInstantHushAccessGranted = this.props.commonReducer && this.props.commonReducer.accessGranted && this.props.commonReducer.accessGranted.isInstantHushAccessGranted;
    const isInstantLeafGranted = this.props.commonReducer && this.props.commonReducer.accessGranted && this.props.commonReducer.accessGranted.isInstantSwitchMCAccessGranted;

    this.setState({
      isInstantConsultAccessGranted,
      isInstantSwitchAccessGranted,
      isInstantHushAccessGranted,
      isInstantLeafGranted
    });
    const { history } = this.props;
    if (isInstantConsultAccessGranted) {
      // navigate to patient's in queue page as both access granted
      if (history) history.push(appRoutes.patientsQueue);
    } else if (isInstantSwitchAccessGranted) {
      // navigate to instant switch page directly as only instant switch access granted
      if (history) history.push(appRoutes.instantSwitch);
    } else if (isInstantHushAccessGranted) {
      // navigate to instant hush page directly as only instant hush access granted
      if (history) history.push(appRoutes.instantHush);
    } else if (isInstantLeafGranted) {
      // navigate to instant leaf page directly as only instant hush access granted
      if (history) history.push(appRoutes.instantLeaf);
    }
  }

  // getForumPostUnreadCount = () => {
  //   this.setState({
  //     apiCall: {
  //       reqType: "GET",
  //       reqURL: getUnreadForumPostCount,
  //       dataObj: {},
  //       params: {},
  //       headers: {},
  //       successCallback: async res => {
  //         this.props.setForumReadTopics(res.data?.data?.count || 0);
  //       },
  //       failureCallback: err => {
  //         console.log("Something went wrong, Please try again ! ", err);
  //         this.setState({
  //           uploadingChatFile: false
  //         });
  //       },
  //       showPopUp: false
  //     }
  //   });
  // };

  getAssessmentsCount() {
    if (this.state.isInstantHushAccessGranted || this.state.isInstantLeafGranted || this.state.isInstantSwitchAccessGranted) {
      this.setState({
        apiCallTodayAssessmentCount: {
          reqType: "GET",
          reqURL: getTodayAssessmentCount,
          dataObj: {},
          params: {},
          headers: {},
          successCallback: res => {
            this.setState({
              apiLoading: false,
              hushToBeAssessedToday: res.data.data?.toBeAssessedToday || "0",
              leafToBeAssessedToday: res.data.data?.medicinalCannabisCount || "0",
              switchToBeAssessedToday: res.data.data?.smokingCessationCount || "0"
            });
          },
          failureCallback: err => {
            console.log("Something went wrong. Please try again ", err);
            this.setState({
              apiLoading: false
            });
          }
        }
      });
    }
  }

  // getHushCount() {
  //   this.setState({
  //     apiCallLHush: {
  //       reqType: "GET",
  //       reqURL: getOrderHistoryWithFilterAPI,
  //       dataObj: {},
  //       params: {
  //         assessmentType: "Instant Hush",
  //         limit: 1
  //       },
  //       headers: {},
  //       successCallback: res => {
  //         this.setState({
  //           apiLoading: false,
  //           hushBeAssessedToday: res.data.data?.toBeAssessedToday || "0"
  //         });
  //       },
  //       failureCallback: err => {
  //         console.log("Something went wrong. Please try again ", err);
  //         this.setState({
  //           apiLoading: false
  //         });
  //       }
  //     }
  //   });
  // }

  // getLeafCount() {
  //   this.setState({
  //     apiCallLeaf: {
  //       reqType: "GET",
  //       reqURL: getOrderHistoryWithFilterAPI,
  //       dataObj: {},
  //       params: {
  //         assessmentType: "Medicinal Cannabis",
  //         limit: 1
  //       },
  //       headers: {},
  //       successCallback: res => {
  //         this.setState({
  //           apiLoading: false,
  //           leafToBeAssessedToday: res.data.data?.toBeAssessedToday || "0"
  //         });
  //       },
  //       failureCallback: err => {
  //         console.log("Something went wrong. Please try again ", err);
  //         this.setState({
  //           apiLoading: false
  //         });
  //       }
  //     }
  //   });
  // }

  // getSwitchCount() {
  //   this.setState({
  //     apiCallLeaf: {
  //       reqType: "GET",
  //       reqURL: getOrderHistoryWithFilterAPI,
  //       dataObj: {},
  //       params: {
  //         assessmentType: "Smoking Cessation",
  //         limit: 1
  //       },
  //       headers: {},
  //       successCallback: res => {
  //         this.setState({
  //           apiLoading: false,
  //           switchBeAssessedToday: res.data.data?.toBeAssessedToday || "0"
  //         });
  //       },
  //       failureCallback: err => {
  //         console.log("Something went wrong. Please try again ", err);
  //         this.setState({
  //           apiLoading: false
  //         });
  //       }
  //     }
  //   });
  // }

  getDoctorOnlineData = () => {
    let apiCallParam = {
      reqType: "GET",
      reqURL: getHomePageData,
      dataObj: {},
      params: {},
      headers: {},
      successCallback: async res => {
        if (res.data && res.data.data) {
          let data = {
            totalConsults: res.data.data.totalConsults,
            numberinQueue: res.data.data.numberinQueue,
            // totalDoctor: res.data.data.totalDoctor,
            totalPatient: res.data.data.totalPatient,
            totalNotifications: res.data.data.totalNotifications,
            waitTime: res.data.data.waitTime,
            waitCount: res.data.data.waitCount,
            newForumPostsCount: res.data.data.newForumPostsCount
          };
          this.props.doctorOnlineData(data);
          this.props.setTotalDoctors(res.data.data.totalDoctor);

          const {
            unReadForumReplyCommentsCount = 0,
            unReadCommentsCount = 0,
            newForumPostsCount = 0
          } = res.data?.data || {};

          this.props.setForumReadTopics(newForumPostsCount);
          this.props.setForumReadComments(unReadCommentsCount + unReadForumReplyCommentsCount);
        }
      },
      failureCallback: err => {
        console.log("Something went wrong, Please try again ! ", err);
        this.setState({
          uploadingChatFile: false
        });
      },
      showPopUp: false
    };
    this.setState({
      apiCall: apiCallParam
    });
  };

  readFormPostAndGoToViewForum = () => {
    // this.setState({
    //   apiCall2: {
    //     reqType: "GET",
    //     reqURL: readForumPostsAPI,
    //     dataObj: {},
    //     params: {
    //       skip: 0,
    //       limit: 100
    //     },
    //     headers: {},
    //     successCallback: async res => {
    //       console.log("Forum post read completed: ", res.data);
    //       await this.props.setForumReadTopics(0);
    //     },
    //     failureCallback: err => {
    //       console.log("Something went wrong, Please try again ! ", err);
    //     },
    //     showPopUp: false
    //   }
    // });
    const { history } = this.props;
    if (history) history.push(appRoutes.viewForum);
  };

  getPatientsInQueue = () => {
    let apiCallParam = {
      reqType: "GET",
      reqURL: patientsInQueue,
      dataObj: {},
      params: {
        skip: 0,
        limit: 100
      },
      headers: {},
      successCallback: async res => {
        this.setState({
          patientsInQueue: res.data.data.appointments.length
        });
        if (window.location.pathname != "/patient/call/accepted")
          if (this.props.commonReducer.appointmentData == null)
            if (
              res.data.data.appointments.length > 0 &&
              this.props.commonReducer.doctorOnlineData.numberinQueue == "1st"
            ) {
              // this.playAudio();
            }
      },
      failureCallback: err => {
        console.log("Something went wrong, Please try again ! ", err);
      },
      showPopUp: false
    };
    this.setState({
      apiCall: apiCallParam
    });
  };

  // playAudio() {
  //   try {
  //     const audioEl = document.getElementsByClassName("audio-element-first")[0];
  //     audioEl.play();
  //   } catch (e) {
  //     console.log("Audio Direct Play Not Allowed By System CatchBlock: ", e);
  //   }
  // }

  toggleShowForumTooltip = () => {
    this.setState({
      showForumTooltip: !this.state.showForumTooltip && !!this.getForumCommentAndTopicCountTooltip()
    });
  };

  getTopicTitle() {
    return this.props.commonReducer.forumReadTopics === 1 ? "Topic" : "Topics";
  }

  getCommentTitle() {
    return this.props.commonReducer.forumReadComments === 1 ? "Comment" : "Comments";
  }

  getForumCommentAndTopicCountTooltip() {
    if (this.props.commonReducer.forumReadTopics && this.props.commonReducer.forumReadComments) {
      return `${this.props.commonReducer.forumReadTopics} ${this.getTopicTitle()} | ${this.props.commonReducer.forumReadComments} ${this.getCommentTitle()}`;
    } else if (this.props.commonReducer.forumReadTopics) {
      return `${this.props.commonReducer.forumReadTopics} ${this.getTopicTitle()}`;
    } else if (this.props.commonReducer.forumReadComments) {
      return `${this.props.commonReducer.forumReadComments} ${this.getCommentTitle()}`;
    }
    return "";
  }

  getForumCommentAndTopicCount() {
    if (this.props.commonReducer.forumReadTopics && this.props.commonReducer.forumReadComments) {
      return `${this.props.commonReducer.forumReadTopics} | ${this.props.commonReducer.forumReadComments}`;
    } else if (this.props.commonReducer.forumReadTopics) {
      return `${this.props.commonReducer.forumReadTopics}`;
    } else if (this.props.commonReducer.forumReadComments) {
      return `${this.props.commonReducer.forumReadComments}`;
    }

    return "";
  }

  render() {
    return (
      <Fragment>
        {
          this.state.isInstantConsultAccessGranted && (
            <Fragment>
              <div className="custom-li list-group">
                <a
                  href="/"
                  className="list-group-item list-group-item-action disabled"
                >
                  <i className="fas fa-user-md font-15 mr-3 primary-color"></i>
                  <Label
                    title="Online Doctors"
                    className="p-0 m-0 font-15 secondary-font"
                  />
                  <Label
                    title={
                      this.props.commonReducer &&
                        // this.props.commonReducer.doctorOnlineData &&
                        this.props.commonReducer.totalDoctor
                        ? this.props.commonReducer.totalDoctor.toString()
                        : "-"
                    }
                    className="gray p-0 m-0 secondary-font primary-color font-15 pt-1 float-right"
                  />
                </a>

                <li className="list-group-item list-group-item-action secondary-font cursor-pointer"
                  onClick={this.readFormPostAndGoToViewForum}>
                  <i className="fas fa-comments font-15 mr-3 primary-color"></i>
                  <Label title="Forum" className="p-0 m-0 font-15 secondary-font" />
                  {(
                    this.props.commonReducer.forumReadTopics + this.props.commonReducer.forumReadComments > 0 ? (
                      <i className="fas fa-envelope font-15 primary-color pt-1 float-right"></i>
                    ) : ('')
                  )}
                  {/*
                  <Tooltip target="forumCommentAndTopicCount" placement="top" isOpen={this.state.showForumTooltip}
                           autohide={true} toggle={this.toggleShowForumTooltip}>
                    {this.getForumCommentAndTopicCountTooltip()}
                  </Tooltip>
                  <Label
                    id="forumCommentAndTopicCount"
                    title={this.getForumCommentAndTopicCount()}
                    className="gray p-0 m-0 secondary-font primary-color font-15 pt-1 float-right"
                  /> */}
                </li>

                <a href="/" className="list-group-item list-group-item-action disabled">
                  <i className="fas fa-clock font-15 mr-3 primary-color"></i>
                  <Label
                    title={`You are ${this.props.commonReducer &&
                      this.props.commonReducer.doctorOnlineData &&
                      this.props.commonReducer.doctorOnlineData.numberinQueue
                      && this.props.commonReducer.doctorOnlineData.numberinQueue !== -1 ? this.props.commonReducer.doctorOnlineData.numberinQueue
                      : "not"
                      } in Queue`}
                    className="p-0 m-0 font-15 secondary-font"
                  />
                </a>
                <NavLink
                  to={appRoutes.patientsQueue}
                  className="list-group-item list-group-item-action"
                  href="#"
                >
                  <i className="fas fa-users font-15 mr-3 primary-color"></i>
                  <Label
                    title="Patients in Queue"
                    className="p-0 m-0 font-15 secondary-font"
                  />
                  <Label
                    title={`${this.props.commonReducer &&
                      this.props.commonReducer.patientsQueueCount ?
                      this.props.commonReducer.patientsQueueCount : "0"
                      }`}
                    // title={this.state.patientsInQueue + ""} patientsQueueCount
                    className="gray p-0 m-0 secondary-font primary-color font-15 pt-1 float-right"
                  />
                </NavLink>
              </div>
              <div className="custom-li list-group mt-4">
                <li
                  className="list-group-item list-group-item-action secondary-font cursor-pointer"
                  onClick={this.checkInternetConnection}
                >
                  <i className="fas fa-wifi font-15 mr-3"></i>
                  <Label
                    title="Test Connection"
                    className="p-0 m-0 font-15 secondary-font"
                  />
                  <CircularProgress
                    disableShrink
                    className={
                      this.state.testingConnectionLoader
                        ? "primary-loader test-connection-loader"
                        : "d-none"
                    }
                  />
                </li>
              </div>

              <div className="custom-li list-group mt-4">
                <NavLink
                  to={appRoutes.notifications}
                  className="list-group-item list-group-item-action secondary-font"
                  href="#"
                >
                  <i className="fas fa-bell font-15 mr-3"></i>
                  <Label
                    title="Notifications"
                    className="p-0 m-0 font-15 secondary-font"
                  />
                </NavLink>
                <NavLink
                  to={appRoutes.consultHistory}
                  className="list-group-item list-group-item-action secondary-font"
                  href="#"
                >
                  <i className="fas fa-history font-15 mr-3"></i>
                  <Label
                    title="Consult History"
                    className="p-0 m-0 font-15 secondary-font"
                  />
                </NavLink>
                <NavLink
                  to={appRoutes.tickets}
                  className="list-group-item list-group-item-action secondary-font"
                  href="#"
                >
                  <i className="fas fa-ticket-alt font-15 mr-3"></i>
                  <Label title="Tickets" className="p-0 m-0 font-15 secondary-font" />
                </NavLink>
                <NavLink
                  to={appRoutes.tagTopicsCPD}
                  className="list-group-item list-group-item-action secondary-font"
                  href="#"
                >
                  <i className="fas fa-tags font-15 mr-3"></i>
                  <Label title="Tagged Topics (CPD MO)" className="p-0 m-0 font-15 secondary-font" />
                </NavLink>
              </div>
            </Fragment>
          )
        }

        {
          (this.state.isInstantSwitchAccessGranted || this.state.isInstantHushAccessGranted || this.state.isInstantLeafGranted) &&
          <div className="custom-li list-group mt-4">
            <img
              src={InstantExtrasLogo} alt="Instant Switch Logo"
              className="list-group-item list-group-item-action instant-extra-logo" />
            <NavLink
              to={appRoutes.instantExtraDoctorSchedule}
              className="list-group-item list-group-item-action secondary-font"
              href="#"
            >
              <i className="fas fa-calendar-alt font-15 mr-3" />
              <Label title="Schedule" className="p-0 m-0 font-15 secondary-font" />
            </NavLink>
          </div>
        }

        {
          this.state.isInstantSwitchAccessGranted && <>
            <div className="custom-li list-group mt-4">
              <img style={{
                objectFit: "contain",
                objectPosition: "left",
                height: "3rem"
              }} src={InstantSwitchLogo} alt="Instant Switch Logo"
                className="list-group-item list-group-item-action instant-switch-nav" />
              <NavLink
                to={appRoutes.instantSwitch}
                className="list-group-item list-group-item-action secondary-font"
                href="#"
              >
                <i className="fas fa-clipboard-list font-15 mr-3" />
                <Label title="To Be Assessed Today" className="p-0 m-0 font-15 secondary-font" />
                <Label
                  title={this.state.switchToBeAssessedToday}
                  className="gray p-0 m-0 secondary-font primary-color font-15 pt-1 float-right"
                />
              </NavLink>
            </div>
          </>
        }

        {
          this.state.isInstantLeafGranted && <>
            <div className="custom-li list-group mt-4">
              <img style={{
                objectFit: "contain",
                objectPosition: "left",
                height: "3rem"
              }} src={InstantLeafLogo} alt="Instant Leaf Logo"
                className="list-group-item list-group-item-action instant-leaf-nav" />
              <NavLink
                to={appRoutes.instantLeaf}
                className="list-group-item list-group-item-action secondary-font"
                href="#"
              >
                <i className="fas fa-clipboard-list font-15 mr-3" />
                <Label title="To Be Assessed Today" className="p-0 m-0 font-15 secondary-font" />
                <Label
                  title={this.state.leafToBeAssessedToday}
                  className="gray p-0 m-0 secondary-font primary-color font-15 pt-1 float-right"
                />
              </NavLink>
            </div>
          </>
        }

        {
          this.state.isInstantHushAccessGranted && <>
            <div className="custom-li list-group mt-4">
              <img style={{
                objectFit: "contain",
                objectPosition: "left",
                height: "3rem"
              }} src={InstantHushLogo} alt="Instant Hush Logo"
                className="list-group-item list-group-item-action instant-switch-nav" />
              <NavLink
                to={appRoutes.instantHush}
                className="list-group-item list-group-item-action secondary-font"
                href="#"
              >
                <i className="fas fa-clipboard-list font-15 mr-3" />
                <Label title="To Be Assessed Today" className="p-0 m-0 font-15 secondary-font" />
                <Label
                  title={this.state.hushToBeAssessedToday}
                  className="gray p-0 m-0 secondary-font primary-color font-15 pt-1 float-right"
                />
              </NavLink>
            </div>
          </>
        }

        <div className="custom-li list-group mt-4">
          <NavLink
            to={appRoutes.profile}
            className="list-group-item list-group-item-action secondary-font"
            href="#"
          >
            <i className="fas fa-user font-15 mr-3"></i>
            <Label title="Profile" className="p-0 m-0 font-15 secondary-font" />
          </NavLink>
          <NavLink
            to={appRoutes.bankDetails}
            className="list-group-item list-group-item-action secondary-font"
            href="#"
          >
            <i className="fas fa-university font-15 mr-3"></i>
            <Label
              title="Bank Details"
              className="p-0 m-0 font-15 secondary-font"
            />
          </NavLink>
          {(this.state.isInstantConsultAccessGranted || this.state.isInstantSwitchAccessGranted || this.state.isInstantHushAccessGranted || this.state.isInstantLeafGranted) && (
            <NavLink
              to={appRoutes.consultCost}
              className="list-group-item list-group-item-action secondary-font"
              href="#"
            >
              <i className="fas fa-dollar-sign font-15 mr-3"></i>
              <Label
                title="Consult Costs"
                className="p-0 m-0 font-15 secondary-font"
              />
            </NavLink>
          )}
        </div>

        <div className="custom-li list-group mt-4">
          <NavLink
            to={appRoutes.paymentSummary}
            className="list-group-item list-group-item-action secondary-font"
            href="#"
          >
            <i className="fas fa-money-bill font-15 mr-3"></i>
            <Label
              title="Payment Summaries"
              className="p-0 m-0 font-15 secondary-font"
            />
          </NavLink>
          <NavLink
            to={appRoutes.taxInvoice}
            className="list-group-item list-group-item-action secondary-font"
            href="#"
          >
            <i className="fas fa-file-invoice font-15 mr-3"></i>
            <Label
              title="Tax Invoices"
              className="p-0 m-0 font-15 secondary-font"
            />
          </NavLink>
        </div>

        <div className="custom-li list-group mt-4">
          <NavLink
            to={appRoutes.help}
            className="list-group-item list-group-item-action secondary-font"
            href="#"
          >
            <i className="fas fa-question-circle font-15 mr-3"></i>
            <Label title="Help" className="p-0 m-0 font-15 secondary-font" />
          </NavLink>
          <NavLink
            to={appRoutes.legal}
            className="list-group-item list-group-item-action secondary-font"
            href="#"
          >
            <i className="fas fa-file font-15 mr-3"></i>
            <Label title="Legal" className="p-0 m-0 font-15 secondary-font" />
          </NavLink>
        </div>

        {/* API Call */}
        <MakeAPICall apiParam={this.state.apiCall} />
        <MakeAPICall apiParam={this.state.apiCall2} />
        <MakeAPICall apiParam={this.state.apiCallTodayAssessmentCount} />

        {/* Testing Connection Popup */}
        <Model
          openModal={this.state.internetConnectionModelOpen}
          className="test-connection-model-body"
          modalBodyContent={
            this.state.internetConnectionModelBody
              ? this.state.internetConnectionModelBody
              : this.state.poorInternetConnection
          }
          okayText="Okay"
          cancelText="Okay"
          title="Instant Consult"
          useOneButton={true}
          okayEvent={this.closeInternetConnectionModel}
          cancelEvent={this.closeInternetConnectionModel}
        />
        {/* Audio element */}
        {/* <audio className="audio-element-first d-none">
          <source src={DingBell}></source>
        </audio> */}
      </Fragment>
    );
  }
}

// export default SideNavBar;
// get the store
const mapStateToProps = props => ({
  auth:
    props.auth.user && props.auth.user.userData ? props.auth.user.userData : {},
  commonReducer: props.commonReducers
});

const mapDispatchToProps = dispatch => ({
  doctorOnlineData: data => dispatch(doctorOnlineData(data)),
  setForumReadTopics: data => dispatch(setForumReadTopics(data)),
  setForumReadComments: data => dispatch(setForumReadComments(data)),
  setTotalDoctors: data => dispatch(setTotalDoctors(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SideNavBar));
